import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { GetKeyVisualsDocument, GetKeyVisualsQuery } from '~/__generated__/graphql'
import { KeyVisualModel } from '../createModel'

const KEY_VISUAL_COUNT = 7

export const useKeyVisual = () => {
  const { data, error, loading } = useQuery<GetKeyVisualsQuery>(GetKeyVisualsDocument, {
    variables: { first: KEY_VISUAL_COUNT },
  })

  return useMemo(() => {
    if (!data?.keyVisualRecommendVideos.edges) {
      return {
        error,
        loading,
        keyVisualModels: [],
      }
    }

    // キービジュアルの各要素を抽出 && 整形
    const keyVisualModels: KeyVisualModel[] = data.keyVisualRecommendVideos.edges
      .filter(({ node }) => node?.landscapeThumbnail)
      .map(({ node }) => {
        const { id, title, description, duration, landscapeThumbnail } = node!

        return {
          id,
          title: title || '',
          image: landscapeThumbnail!,
          videoInfo: {
            id,
            minutes: duration.minutes || 0,
            seconds: duration.seconds || 0,
            description: description || '',
          },
        }
      })

    return {
      error,
      loading,
      keyVisualModels,
      attributionToken: data.keyVisualRecommendVideos.attributionToken ?? undefined,
    }
  }, [data, error, loading])
}
